export default {
    namespaced: true,
    state() {
        return {
            chatRooms: [],
            showChatContainer: false,
            activeConversation: 0
        }
    },
    mutations: {
        SET_CHAT_ROOMS(state, payload) {
            state.chatRooms = payload;
        },
        SET_SHOW_CHAT_CONTAINER(state, payload) {
            state.showChatContainer = payload;
        },
        SET_ACTIVE_CONVERSATION(state, payload) {
            state.activeConversation = payload;
        },
    }
}